import request from '@/utils/request'
import { clearify } from "@/utils/encryptor";
//const siteName = 'https://cms-demo-server.descpro.com'
//const siteName = 'http://localhost:52460'
const siteName = process.env.VUE_APP_BASE_API;
//const siteName = 'http://192.168.1.125:9991'
//const siteName = 'http://localhost:5000'
//const siteName = 'http://166.62.44.194:5000'
//const siteName = 'http://192.168.100.220:8082'

export function login(username, password) {
  const payload = {
    RequestId: Math.floor(Math.random() * 10000000000 + 1),
    Data: {
      Username: username,
      Password: password
    }
  }
  let data = JSON.stringify(payload)

  return request({
    url: siteName + '/api/token',
    method: 'post',
    data,
    headers: {
      'content-type': 'application/json'
    }
  })
}
export function logout() {
  return request({
    url: '/login/logout',
    method: 'post'
  })
}

export function getUserInfo() {
  const payload = {
    RequestId: Math.floor(Math.random() * 10000000000 + 1),
    Data: ''
  }
  let data = JSON.stringify(payload)
  return request({
    url: siteName + '/api/Token/GetCurrentUser',
    method: 'post',
    data,
    headers: {
      'content-type': 'application/json'
    }
  })
}
export function returnURL() {
  try {
    // console.log("🚀 ~ file: login.js:55 ~ returnURL ~ siteName:", siteName)
    return siteName;
    let s = document.getElementById('baseurl').getAttribute('url')
    // console.log(process.env.VUE_APP_BASE_URL);
    // let s = document.getElementById('baseurl').getAttribute('url')
    // let s = process.env.VUE_APP_BASE_URL;
    let d = clearify(s, 19);
    if (d != undefined) {
      return d;
    } else {
      return ""
    }

  } catch {
    return ""
  }
}
// export function returnURL() {
//   return siteName
// }
